var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12 1v22M23 12H1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddStroke);
export default __webpack_public_path__ + "static/media/add-stroke.1d6e5091d8125545dc8ed6e7f51fc1fa.svg";
export { ForwardRef as ReactComponent };